const Configuration = {
  authorizationEndpoint: process.env.REACT_APP_AUTHORIZATION_EP,
  tokenEndpoint: process.env.REACT_APP_TOKEN_EP,
  clientId: process.env.REACT_APP_CLIENT_ID,
  redirectUri: process.env.REACT_APP_REDIRECT_EP,
  logoutEndpoint: process.env.LOGOUT_EP,
  scopes: "employeeInfo openid",
};

export default Configuration;
